import { apiRequestActions } from '@ackee/redux-utils';
import { fetchOtherDocumentsTypes } from './types';

export default apiRequestActions(fetchOtherDocumentsTypes);
